import {Modal} from "react-bootstrap";
import {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {IrregularityDecisionForm} from "./IrregularityDecisionForm";

export function IrregularityDecisionModal({show, setShow, irregularity, candidatureExternalId, onSubmitCallback}) {
    const intl = useIntl();
    const [error, setError] = useState(null);
    const [entity, setEntity] = useState(null);

    async function onSubmit() {
        try {
            setShow(false);
            onSubmitCallback?.()
        } catch (error) {
            setError(error);
        }
    }

    function handleClose() {
        setShow(false);
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title><FormattedMessage id='candidatureTabs.oversight.tabs.irregularities.decide' /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <IrregularityDecisionForm
                    onSubmitCallback={onSubmit}
                    irregularity={irregularity}
                    candidatureExternalId={candidatureExternalId}
                    onCancel={() => setShow(false)}
                />
            </Modal.Body>
        </Modal>

    );
}